import { Breakpoint, ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';
import { MediaProps } from '../Media';
import { TextProps } from '../Text';
import { CardProps } from '../Card';
import { NavigationItemProps } from '../NavigationItem';

export enum CollectionVariants {
  threePerRow = 'three-per-row',
  fourPerRow = 'four-per-row',
  accordion = 'accordion'
}

export interface CollectionProps {
  variant?: CollectionVariants;
  id: string;
  __typename?: string;
  items?: CardProps[] | NavigationItemProps[];
  background?: MediaProps;
  introText?: TextProps;
  itemsVariant?: string;
  itemsSpacing?: number;
  itemsWidth?: false | Breakpoint;
  styles?: any;
  theme?: any;
  sidekickLookup?: any;
  requireLogin?: boolean;
}

export interface CollectionOwnerState extends CollectionProps {}

export interface CollectionClasses {
  /** Styles applied to the root element. */
  root: string;
  /** Styles applied to the content cotainer when itemsWidth is set. */
  contentContainer: string;
  /** Styles applied to the intro text root container. */
  introText: string;
}

export declare type CollectionClassKey = keyof CollectionClasses;

declare module '@mui/material' {
  export interface ComponentNameToClassKey {
    Collection: CollectionClassKey;
  }

  export interface ComponentsPropsList {
    Collection: CollectionProps;
  }
}

declare module '@mui/material' {
  interface Components {
    Collection?: {
      defaultProps?: ComponentsProps['Collection'];
      styleOverrides?: ComponentsOverrides['Collection'];
      variants?: ComponentsVariants['Collection'];
    };
  }
}
